<template>
    <div class="scc-image-with-text" :style="componentStyle">
        <div class="scc-image-with-text__inner-container">
            <div class="scc-image-with-text__box">
                <h3 class="scc-image-with-text__title">{{ title }}</h3>
                <p class="scc-image-with-text__text">{{ text }}</p>
                <router-link class="scc-image-with-text__cta-button" :to="`/${buttonLinkTo}`">{{
                    buttonText
                }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import './image-with-text.scss';

export default {
    name: 'ImageWithText',
    __editor: {
        fields: {
            backgroundImage: {
                widget: 'media',
            },
        },
    },
    props: {
        backgroundImage: String,
        title: {
            type: String,
            default: 'Titel',
        },
        text: {
            type: String,
            default: 'Tekst',
        },
        buttonText: {
            type: String,
            default: 'Aanmelden',
        },
        buttonLinkTo: {
            type: String,
            default: 'aanmelden',
        },
    },
    computed: {
        componentStyle() {
            return `background-image: url(${this.backgroundImage})`;
        },
    },
};
</script>
